import { UserType } from 'v2/core/entities/user';

export const isSuperUserType = (userType: UserType) => {
  return (
    userType === UserType.SuperManager ||
    userType === UserType.SuperAdmin ||
    userType === UserType.SuperViewer ||
    userType === UserType.SuperEditor
  );
};
